import styled, { css } from "styled-components";
import { ADMIN_LK } from "@constants";

export const RootContainer = styled.div`
  height: calc(100vh - 70px);
  overflow: hidden;
  position: relative;
`;

export const EmptyText = styled.div`
  height: ${props => `calc(100vh - 181px - ${props.optHeight}px)`};
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  color: #808080;
`;

export const Container = styled.div.attrs({
  id: "scrollableDiv",
})`
  width: 100%;
  height: ${props => `calc(100vh - 181px - ${props.optHeight}px)`};
  padding: 0 0 12px 0;
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
`;

export const MessageText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 1.5;
color: #342309;

a {
    color: #1677ff !important;

    :active {
      color: #1677ff !important;
    }
  }
`;

export const DateText = styled.div`
  margin-bottom: 6px;
  margin-top: 16px;
  font-size: 12px;
  font-weight: 400;
  color: #9B92BB;
  text-align: center;
`;

export const SpinWrapper = styled.div`
  padding: 14px;
  text-align: center;
`;

const styles = css`
  height: ${props => `calc(100vh - 181px - ${props.optHeight}px)`};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const InitialMessage = styled.div`
  ${(props) => props.size === "large" && styles}

  >div {
    margin-top: 16px;
    margin-left: 16px;
    padding: 12px;
    border-radius: 12px;
    background-color: #E5E0F5;
    max-width: 250px;
    white-space: pre-wrap;
    word-break: break-word;
    width: fit-content;
    text-align: left;
    align-self: flex-start;
    position: relative;

    ::before {
      width: 10px;
      height: 10px;
      position: absolute;
      top: 12px;
      left: -2px;
      background: #E5E0F5;
      content: "";
      transform: rotate(-45deg);
    }

    @media screen and (max-width: 480px) {
      width: fit-content;
      max-width: 60vw !important;
    }
  }

  ${MessageText} {
    line-height: 1.5;
  }
`;

export const NameText = styled.span`
padding-right: 5px;
font-size: 10px;
font-style: normal;
font-weight: 500;
line-height: 1.5;
color: #9027E1;
`;

export const TimeText = styled.span`
font-size: 10px;
font-style: normal;
font-weight: 400;
color: #9B92BB;
line-height: 1.5;
`;

export const TimeWrapper = styled.div`
display: flex;
align-items: center;
`;

export const MessageItem = styled.div`
margin: 0 16px 16px 16px;
padding: 12px;
border-radius: 12px;
background-color: ${props => props.sender === ADMIN_LK ? '#E5E0F5' : '#49028E'};
max-width: 250px;
white-space: pre-wrap;
word-break: break-word;
width: fit-content;
text-align: ${props => props.sender === ADMIN_LK ? 'left' : 'right'};
align-self: ${props => props.sender === ADMIN_LK ? 'flex-start' : 'flex-end'};
position: relative;
display: flex;
flex-direction: column;

::before {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 12px;
  right: ${props => props.sender === ADMIN_LK ? 'auto' : '-2px'};
  left: ${props => props.sender === ADMIN_LK ? '-2px' : 'auto'};
	background: ${props => props.sender === ADMIN_LK ? '#E5E0F5' : '#49028E'};
  content: "";
  transform: rotate(-45deg);
}

${MessageText} {
  color: ${props => props.sender === ADMIN_LK ? '#342309' : '#fff'};
}

${TimeWrapper} {
justify-content: ${props => props.sender === ADMIN_LK ? 'flex-start' : 'flex-end'};
}

.anticon {
  color: #E1A59C;
}

@media screen and (max-width: 480px) {
  width: fit-content;
  max-width: 60vw !important;
}
`;